export default {
    data() {
        return {

        }
    },

    watch: {

    },

    created() {

    },

    methods: {
        close() {
            this.$emit('close')
        }
    }
}
